import { render, staticRenderFns } from "./BellNotificationTemplatesModal.vue?vue&type=template&id=117de14e"
import script from "./BellNotificationTemplatesModal.vue?vue&type=script&lang=js"
export * from "./BellNotificationTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports